import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import { Trans, useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import useSignIn from '../../hooks/useSignIn';

function SignInForm() {
    const { t } = useTranslation('signIn');
    const {
        phoneNo, onChangeValue, smsAuthNo, onChangeCode, requestSms, requestVerify,
        requestColor, verityColor,
    } = useSignIn();
    const isEmail = useIsEmailSignIn();
    const placeholderKey = isEmail ? 'phone.emailPlaceholder'
        : 'phone.phonePlaceholder';
    const subtitleKey = isEmail ? 'phone.subtitleEmail' : 'phone.subtitle';
    const titleKey = isEmail ? 'phone.titleEmail' : 'phone.title';
    return (
        <Column fullWidth as='section' className={styles.container} spacing={12}>
            <Text size='xl' fontWeight='bold'>{t(titleKey)}</Text>
            <Text color={colors.gray7}
                size='lg'
                fontWeight='bold'
                className={styles.comment} >
                {t(subtitleKey)}
            </Text>
            <Column fullWidth spacing={12}>
                <TextField value={phoneNo}
                    onChange={onChangeValue}
                    placeholder={t(placeholderKey)}
                    inputMode={isEmail ? 'email' : 'numeric'}
                    maxLength={isEmail ? 100 : 13}
                    trailing={
                        <ButtonWrapper type='button'
                            onClick={requestSms} >
                            <Text fontWeight='bold' color={requestColor}
                                className={styles.button} >{t('phone.requestCode')}</Text>
                        </ButtonWrapper>
                    } />
                <TextField value={smsAuthNo}
                    onChange={onChangeCode}
                    placeholder={t('phone.codePlaceholder')}
                    inputMode='numeric'
                    maxLength={6}
                    trailing={
                        <ButtonWrapper onClick={requestVerify}
                            type='button' >
                            <Text fontWeight='bold' color={verityColor}
                                className={styles.button} >{t('phone.verifyCode')}</Text>
                        </ButtonWrapper>
                    } />
            </Column>
            <Row spacing={6}>
                <Text color={colors.gray5}
                    size='s' >
                    <Trans ns='signIn'
                        i18nKey='phone.privacyConsignee'
                        components={{ b: <b/> }} />
                </Text>
                <div className={styles.div}/>
                <Text color={colors.gray5}
                    size='s' >
                    <Trans ns='signIn'
                        i18nKey='phone.privacyPurpose'
                        components={{ b: <b/> }} />
                </Text>
            </Row>
        </Column>
    );
}

const ButtonWrapper = styled.button`
    padding: 8px 12px;
    background-color: transparent;
`;

export default SignInForm;
